import HttpCLient from '@/src/lib/utils/httpClient';
import { ApiRouts } from '@/src/routes/routes';
import { ProfileRequest, User } from '@/src/types/Profile';
import { cache } from 'react';

class ProfileServices extends HttpCLient {
  getProfile = async () => {
    return await this.get<ProfileRequest>(ApiRouts.profile, undefined, {
      cache: 'force-cache',
    });
  };

  updateProfile = async (data: User) => {
    return await this.put<ProfileRequest>(ApiRouts.profileEdit, data);
  };
}
export const profileServices = new ProfileServices();
